module.exports = __webpack_public_path__ + "static/img/decorate-4.6b7abdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/images/decorate-4.png
// module id = KqoU
// module chunks = 64